import type { FaireProductEntity } from "../../entity_types/product";

export const p_xs3xc4fn93: FaireProductEntity = {
  token: "p_xs3xc4fn93",
  type: "product",
  name: "Spiced Coconut Chai - Wholesale",
  brandToken: "b_7piiqmq04r",
  brandName: "Lake & Oak Tea Co.",
  imageUrl: "https://cdn.faire.com/fastly/f3292823e84b5a1b014f5d3ba2e594792118e273d3e5c2c4a33928e677961884.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/080d3bf0b53ce621bc850584c650f5d65e7404656ff5806c97565357dfc99b55.png",
    "https://cdn.faire.com/fastly/d9dd6d503bd02cd6cabc36ff3d06a90d88706c2c7445ac8382575e0b043f7f18.jpeg"
  ],
  priceDollars: 30,
  description: "SUPERFOOD TEA BLEND\n\nThe chai with it’s own fan club. This comforting tea is rockin’ superfoods tulsi, ginger and cinnamon, for a sip that’s pleasantly spicy and sweet. Rooibos makes it a natural caffeine-free dream, great for mellowing out at any time of day.\n\n100% ORGANIC - ADAPTOGENIC - NUTRITIONIST FORMULATED\n\nHow to Enjoy:\n\n * Steep tea in 1 cup of 98° water for 4-6 minutes. \n * Try me with a splash of milk and honey. \n * Tea Latte: Steep tea double strength and top with frothed milk, vanilla and sweetener. \nWhen to Steep:\n\n\n * A nourishing all day caffeine-free tea \n * To calm your nerves \n * To soothe your stomach between meals \n * To boost immunity with superfoods \n * As a sugar-free treat before bed. \nCaffeine-free\n",
  tags: [],
  msrpDollars: 60,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-07T19:04:38.331Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
